import React, {Component} from 'react';
import FilterByGames from 'components/organisms/filter-by-games';
import Players from 'desktop/elements/players';
import Lineups from 'desktop/elements/lineups';
import Messages from 'components/molecules/message/global';
import SiteSwitch from 'components/organisms/site-switch';
import SportSwitch from 'components/organisms/sport-switch';
import GameSwitch from 'components/organisms/game-switch';
import SlateSwitch from 'components/organisms/slate-switch';
import ModeSwitch from 'components/organisms/mode-switch';

class SlateComponent extends Component {
    render() {
        return (
            <>
                <Messages />
                <div className="white-box">
                    <div className="main-filter">
                        <ModeSwitch />
                        <SiteSwitch />
                        <SportSwitch />
                        <GameSwitch />
                        <SlateSwitch />
                    </div>
                    <FilterByGames />
                </div>
                <Players />
                <Lineups />
            </>
        );
    }
}

export default SlateComponent;
